import { message } from "antd";
import { authHeader } from "../../../helpers/auth-header";
import { client } from "../../../actions";
import uri from "../constants/uri";

const getFlats = async (houseId, fileId) => {
  try {
		const response = await client.get(`${uri}/flats`, {
      headers: authHeader(),
      params: {houseId, fileId}
    });
    return response.data;
	} catch (error) {
		console.error(error);
		message.error("Не удалось загрузить адреса");
	}
}

export default getFlats;